var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/object-keys.js
// module id = 163
// module chunks = 0